module.exports = __webpack_public_path__ + "img/methadone.ed7e347a.png";